// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elt-wp-plugin {
  .cp_ipselect_wrapper {
    margin: 2em auto;
    min-width: 30vw; /* 最低幅を30vwに設定 */
    width: 100%;
    max-width: 100%; /* 幅が親要素を超えないように設定 */
  }
  
  .cp_ipselect_label {
    display: flex;
    flex-direction: column;
    margin-bottom: 0.1em;
    font-size: 1.4rem;
    color: #2a3d86;
    text-align: left;
    font-weight: bold !important; /* フォントの太さを強制適用 */
  }
  
  .cp_ipselect_message {
    font-size: 1.4rem; /* 小さいフォントサイズ */
    color: #666; /* 普通のフォント色 */
    margin-top: 0.5rem;
  }

  .cp_ipselect02 {
    position: relative;
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
    border-radius: 0.125rem; /* 角丸の設定 */
    background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8); /* グラデーションの枠線 */
    padding: 2px; /* グラデーションの幅 */
  }
  
  .cp_ipselect02 select {
    width: 100%;
    padding: 1rem 4.5rem 1rem 1rem;
    color: #2a3d86;
    cursor: pointer;
    text-overflow: ellipsis;
    border-radius: 0.125rem; /* 内側の要素にも角丸を適用 */
    border: none;
    outline: none;
    background: #f7f9ff; /* セレクトボックスの背景色 */
    background-clip: padding-box; /* 背景色がグラデーションに影響しないようにする */
    /* 標準のスタイルを無効にする */
    border: none;
    appearance: none;
    outline: none;
    font-size: 1.4rem;
  }

  /*プルダウンの三角と枠を設定*/
  .cp_ipselect02::before {
    position: absolute;
    right: 15px;
    content: '';
    width: 1.4rem;
    height: 0.8rem;
    background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);
    clip-path: polygon(0 0, 100% 0, 50% 100%);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/PlanSelector.css"],"names":[],"mappings":"AAAA;EACE;IACE,gBAAgB;IAChB,eAAe,EAAE,gBAAgB;IACjC,WAAW;IACX,eAAe,EAAE,oBAAoB;EACvC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,4BAA4B,EAAE,iBAAiB;EACjD;;EAEA;IACE,iBAAiB,EAAE,eAAe;IAClC,WAAW,EAAE,aAAa;IAC1B,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,uBAAuB,EAAE,UAAU;IACnC,6DAA6D,EAAE,eAAe;IAC9E,YAAY,EAAE,cAAc;EAC9B;;EAEA;IACE,WAAW;IACX,8BAA8B;IAC9B,cAAc;IACd,eAAe;IACf,uBAAuB;IACvB,uBAAuB,EAAE,iBAAiB;IAC1C,YAAY;IACZ,aAAa;IACb,mBAAmB,EAAE,iBAAiB;IACtC,4BAA4B,EAAE,2BAA2B;IACzD,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,iBAAiB;EACnB;;EAEA,gBAAgB;EAChB;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,aAAa;IACb,cAAc;IACd,6DAA6D;IAC7D,yCAAyC;EAC3C;AACF","sourcesContent":[".elt-wp-plugin {\n  .cp_ipselect_wrapper {\n    margin: 2em auto;\n    min-width: 30vw; /* 最低幅を30vwに設定 */\n    width: 100%;\n    max-width: 100%; /* 幅が親要素を超えないように設定 */\n  }\n  \n  .cp_ipselect_label {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 0.1em;\n    font-size: 1.4rem;\n    color: #2a3d86;\n    text-align: left;\n    font-weight: bold !important; /* フォントの太さを強制適用 */\n  }\n  \n  .cp_ipselect_message {\n    font-size: 1.4rem; /* 小さいフォントサイズ */\n    color: #666; /* 普通のフォント色 */\n    margin-top: 0.5rem;\n  }\n\n  .cp_ipselect02 {\n    position: relative;\n    display: flex;\n    align-items: center;\n    margin-bottom: 0.5rem;\n    border-radius: 0.125rem; /* 角丸の設定 */\n    background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8); /* グラデーションの枠線 */\n    padding: 2px; /* グラデーションの幅 */\n  }\n  \n  .cp_ipselect02 select {\n    width: 100%;\n    padding: 1rem 4.5rem 1rem 1rem;\n    color: #2a3d86;\n    cursor: pointer;\n    text-overflow: ellipsis;\n    border-radius: 0.125rem; /* 内側の要素にも角丸を適用 */\n    border: none;\n    outline: none;\n    background: #f7f9ff; /* セレクトボックスの背景色 */\n    background-clip: padding-box; /* 背景色がグラデーションに影響しないようにする */\n    /* 標準のスタイルを無効にする */\n    border: none;\n    appearance: none;\n    outline: none;\n    font-size: 1.4rem;\n  }\n\n  /*プルダウンの三角と枠を設定*/\n  .cp_ipselect02::before {\n    position: absolute;\n    right: 15px;\n    content: '';\n    width: 1.4rem;\n    height: 0.8rem;\n    background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);\n    clip-path: polygon(0 0, 100% 0, 50% 100%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
